import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

const authSelector = (state: RootState) => state.users;

export const loggedInUserSelector = createSelector(
  authSelector,
  (authState) => authState.loggedInUser,
);

export const user = createSelector(authSelector, (authState) => authState.user);
